/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Данные из UI, необходимые для авторизации
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * Имя пользовтеля
     * @type {string}
     * @memberof LoginDto
     */
    username?: string | null;
    /**
     * Электронная почта
     * @type {string}
     * @memberof LoginDto
     */
    email?: string | null;
    /**
     * Пароль
     * @type {string}
     * @memberof LoginDto
     */
    password: string;
    /**
     * Ссылка для редиректа после авторизации
     * @type {string}
     * @memberof LoginDto
     */
    returnUrl?: string | null;
    /**
     * Ссылка для редиректа после авторизации
     * @type {boolean}
     * @memberof LoginDto
     */
    rememberLogin?: boolean;
}

/**
 * Check if a given object implements the LoginDto interface.
 */
export function instanceOfLoginDto(value: object): value is LoginDto {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function LoginDtoFromJSON(json: any): LoginDto {
    return LoginDtoFromJSONTyped(json, false);
}

export function LoginDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginDto {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'password': json['password'],
        'returnUrl': json['returnUrl'] == null ? undefined : json['returnUrl'],
        'rememberLogin': json['rememberLogin'] == null ? undefined : json['rememberLogin'],
    };
}

export function LoginDtoToJSON(json: any): LoginDto {
    return LoginDtoToJSONTyped(json, false);
}

export function LoginDtoToJSONTyped(value?: LoginDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'password': value['password'],
        'returnUrl': value['returnUrl'],
        'rememberLogin': value['rememberLogin'],
    };
}

